// extracted by mini-css-extract-plugin
export default {"item":"Item_item__WA7Gi","itemSelected":"Item_itemSelected__iPuVl","itemCompleted":"Item_itemCompleted__IGtD2","concluded":"Item_concluded__AgL4L"};